export default __webpack_public_path__ + "static/media/githubIcon.bf17abb6.png";